import { makeObservable, computed } from 'mobx';

import LazyLoadingKeyValueStore, {
  EventBasedTransport,
} from '@codefluegel/lazy-loading-key-value-store';
import { FireSafetyEntry } from '../types/transport';

export default class FireSafetyStore extends LazyLoadingKeyValueStore<FireSafetyEntry> {
  constructor(transport: EventBasedTransport<FireSafetyEntry>) {
    super(transport);
    makeObservable(this, {
      allEntries: computed,
      updateFireCategory: false,
    });
  }

  get allEntries(): FireSafetyEntry[] {
    return this.entriesArray;
  }

  updateFireCategory(
    key: string,
    value: FireSafetyEntry | null,
  ): Promise<void> {
    return this.transport.setEntry(key, value);
  }
}
